import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { CommonModule } from '@angular/common'
import { LandingHeaderComponent } from './landing-header/landing-header.component'
import { AppRoutingModule } from '../app-routing.module'
import { RequestAccountPannelComponent } from './request-account-pannel/request-account-pannel.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime'
import { AdminReportSidebarComponent } from './admin-report-sidebar/admin-report-sidebar.component'
import { ApplicationActivitySummaryComponent } from './application-activity-summary/application-activity-summary.component'
import { AdminSocialMediaSummaryComponent } from './admin-social-media-summary/admin-social-media-summary.component'
import { TopDistrictsComponent } from './top-districts/top-districts.component'
import { OnlineAccountsComponent } from './online-accounts/online-accounts.component'
import { MostOrderedProductsComponent } from './most-ordered-products/most-ordered-products.component'
import { WelcomeDetailsComponent } from './welcome-details/welcome-details.component'
import { NavigationComponent } from './navigation/navigation.component'
import { DataTableComponent } from './data-table/data-table.component'
import { RegisterAccountPannelComponent } from './register-account-pannel/register-account-pannel.component'
import { NgxPaginationModule } from 'ngx-pagination'
import { FarmerDistributionComponent } from './farmer-distribution/farmer-distribution.component'
import { HighchartsChartModule } from 'highcharts-angular'
import { HttpClientModule, HttpClient } from '@angular/common/http'
import { NgxChartsModule } from '@swimlane/ngx-charts'
import { QuillModule } from 'ngx-quill'
import { EditModalComponent } from './edit-modal/edit-modal.component'
import { AppDashboardNavigationComponent } from './app-dashboard-navigation/app-dashboard-navigation.component'
import { DiagnosisTableComponent } from './diagnosis-table/diagnosis-table.component'
import { UnderdevelopmentComponent } from './underdevelopment/underdevelopment.component'
import { OrderModule } from 'ngx-order-pipe'
import { FilterPipe } from './pipes/filter.pipe'
import { MultiSelectModule } from 'primeng/multiselect'
import { DropdownModule } from 'primeng/dropdown'
import { TabViewModule } from 'primeng/tabview'
import { TooltipModule } from 'primeng/tooltip'
import { CodeHighlighterModule } from 'primeng/codehighlighter'
import { FalsyFilter } from './pipes/falsy-filter'
import { StringReplace } from './pipes/stringReplace'

// Edit Inputs
import { EditInputComponent } from './edit-input/edit-input.component'
import { EditDiagnosisModalComponent } from './edit-diagnosis-modal/edit-diagnosis-modal.component'
import { PostDiagnosisModalComponent } from './post-diagnosis-modal/post-diagnosis-modal.component'
import { SuccessModalComponent } from './success-modal/success-modal.component'
import { AddInputComponent } from './add-input/add-input.component'
import { OrderChartComponent } from './order-chart/order-chart.component'
import { ChartsModule } from 'ng2-charts'
import { AddCropModalComponent } from './add-crop-modal/add-crop-modal.component'
import { CropsTableComponent } from './crops-table/crops-table.component'
import { TableModule } from 'primeng/table'
import { TruncateTextPipe } from '../truncate-text.pipe'
import { SmartDiagnosisComponent } from './smart-diagnosis/smart-diagnosis.component'
import { SmartDiagnosisPestComponent } from './smart-diagnosis-pest/smart-diagnosis-pest.component'
import { DigitOnlyModule } from '@uiowa/digit-only'

import { CalendarModule } from 'primeng/calendar'
import { InputTextModule } from 'primeng/inputtext'
import { CheckboxModule } from 'primeng/checkbox'
import { AutoCompleteModule } from 'primeng/autocomplete'


import { CountdownPipe } from './pipes/countdown.pipe';

import { FertigationComponent } from './fertigation/fertigation.component'
import { EditorComponent } from './editor/editor.component'
import { InquiriesComponent } from './inquiries/inquiries.component'
import { NutritionComponent } from './nutrition/nutrition.component'
import { DateFormatPipe } from './pipes/date-pipe.pipe'
import { GoogleMapsComponent } from './google-maps/google-maps.component'
import { AgmCoreModule } from '@agm/core'
import { environment } from 'src/environments/environment'
import { VillageAgentsComponent } from './village-agents/village-agents.component'
import { EzyIconsComponent } from '../ezy-icons/ezy-icons.component'
import { ModalComponent } from './modal/modal.component'
import { RouterModule } from '@angular/router'
import { PrintLayoutComponent } from './print-layout/print-layout.component'
import { PurchaseOrderReceiptComponent } from './purchase-order-receipt/purchase-order-receipt.component'
import { PhonePipe } from './pipes/phone.pipe'
import { shortNumber } from './pipes/short-currency.pipe'
import { DiagnosisInquiryComponent } from './diagnosis-inquiry/diagnosis-inquiry.component'
import { PermissionDirective } from './directives/permission.directive'
import { CropDiagnosisTableComponent } from './crop-diagnosis-table/crop-diagnosis-table.component'
import { AnimalDiagnosisTableComponent } from './animal-diagnosis-table/animal-diagnosis-table.component'
import { SpinnerDirective } from './directives/spinner.directive'
import { PermissionLock } from './directives/disabled-permission.directive'
import { PermissionsPipe } from './pipes/permissions'

@NgModule({
  declarations: [
    LandingHeaderComponent,
    RequestAccountPannelComponent,
    AdminReportSidebarComponent,
    ApplicationActivitySummaryComponent,
    AdminSocialMediaSummaryComponent,
    TopDistrictsComponent,
    OnlineAccountsComponent,
    MostOrderedProductsComponent,
    WelcomeDetailsComponent,
    NavigationComponent,
    DataTableComponent,
    RegisterAccountPannelComponent,
    FarmerDistributionComponent,
    EditModalComponent,
    AppDashboardNavigationComponent,
    DiagnosisTableComponent,
    UnderdevelopmentComponent,
    EditDiagnosisModalComponent,
    PostDiagnosisModalComponent,
    SuccessModalComponent,
    AddInputComponent,
    EditInputComponent,
    SuccessModalComponent,
    OrderChartComponent,
    AddCropModalComponent,
    FilterPipe,
    CropsTableComponent,
    TruncateTextPipe,
    SmartDiagnosisComponent,
    SmartDiagnosisPestComponent,
    CropDiagnosisTableComponent,
    FalsyFilter,
    FertigationComponent,
    EditorComponent,
    StringReplace,
    InquiriesComponent,
    NutritionComponent,
    DateFormatPipe,
    GoogleMapsComponent,
    AnimalDiagnosisTableComponent,
    VillageAgentsComponent,
    EzyIconsComponent,
    ModalComponent,
    ModalComponent,
    PrintLayoutComponent,
    PrintLayoutComponent,
    PurchaseOrderReceiptComponent,
    PhonePipe,
    shortNumber,
    DiagnosisInquiryComponent,
    CountdownPipe,
    PermissionDirective,
    SpinnerDirective,
    PermissionLock,
    PermissionsPipe
  ],
  exports: [
    LandingHeaderComponent,
    RequestAccountPannelComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FilterPipe,
    AdminReportSidebarComponent,
    ApplicationActivitySummaryComponent,
    AdminSocialMediaSummaryComponent,
    TopDistrictsComponent,
    OnlineAccountsComponent,
    MostOrderedProductsComponent,
    WelcomeDetailsComponent,
    NavigationComponent,
    DataTableComponent,
    RegisterAccountPannelComponent,
    FarmerDistributionComponent,
    EditModalComponent,
    AppDashboardNavigationComponent,
    DiagnosisTableComponent,
    UnderdevelopmentComponent,
    PostDiagnosisModalComponent,
    SuccessModalComponent,
    AddInputComponent,
    EditInputComponent,
    SuccessModalComponent,
    OrderChartComponent,
    AddCropModalComponent,
    CropsTableComponent,
    TruncateTextPipe,
    SmartDiagnosisComponent,
    SmartDiagnosisPestComponent,
    CropDiagnosisTableComponent,
    FalsyFilter,
    FertigationComponent,
    EditorComponent,
    StringReplace,
    InquiriesComponent,
    NutritionComponent,
    AutoCompleteModule,
    DateFormatPipe,
    PhonePipe,
    shortNumber,
    GoogleMapsComponent,
    AnimalDiagnosisTableComponent,
    VillageAgentsComponent,
    EzyIconsComponent,
    ModalComponent,
    DiagnosisInquiryComponent,
    CountdownPipe,
    PermissionDirective,
    SpinnerDirective,
    PermissionLock,
    PermissionsPipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxPaginationModule,
    HighchartsChartModule,
    HttpClientModule,
    NgxChartsModule,
    OrderModule,
    QuillModule.forRoot(),
    ChartsModule,
    TableModule,
    MultiSelectModule,
    DropdownModule,
    TabViewModule,
    TooltipModule,
    CodeHighlighterModule,
    DigitOnlyModule,
    CalendarModule,
    InputTextModule,
    CheckboxModule,
    AutoCompleteModule,
    AgmCoreModule.forRoot({
      apiKey: environment.GOOGLE_MAPS_KEY,
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule {
}
